<template>
    <div class="wrapper">
        <NavBar />
        <Menu />
        <!-- Spinner Start -->
        <div id="spinner" v-if="halamanloading"
            class="show bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center"
            style="opacity: 0.5;">
            <div class="spinner-border text-danger" style="width: 3rem; height: 3rem;" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
        <!-- Spinner End -->
        <div class="content-wrapper py-3">
            <div class="content-header">
                <div class="container-fluid">
                    <div class="row mb-2">
                        <div class="col-sm-6 wow fadeInDown">
                            <h5>Pengaturan</h5>
                        </div>
                        <div class="col-sm-6 wow fadeInDown">
                            <ol class="breadcrumb float-sm-right">
                                <li class="breadcrumb-item"><a href="/Dashboard">Home </a></li>
                                <li class="breadcrumb-item"><a href="/Konsultan">Monitoring Evaluasi</a></li>
                                <li class="breadcrumb-item active">Pengaturan Kendala Dan Tindak Lanjut</li>
                            </ol>
                        </div>
                    </div><!-- /.row -->
                </div><!-- /.container-fluid -->
            </div>
            <!-- /.content-header -->
            <div class="content">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-sm-12 wow fadeInDown">
                            <div class="card cardputih2 collapsed-card">
                                <div class="card-header border-transparent" data-card-widget="collapse"
                                    style="cursor: pointer;">
                                    <h3 class="card-title">Form Input Kendala Dan Tindak Lanjut</h3>
                                    <div class="card-tools">
                                        <button type="button" class="btn btn-tool" data-card-widget="collapse">
                                            <i class="fas fa-plus"></i>
                                        </button>
                                    </div>
                                </div>
                                <div class="card-body p-3">
                                    <div class="row">
                                        <div class="col-sm-12">
                                            Paket Pekerjaan: {{ Nama_Kegiatan }}
                                        </div>
                                        <div class="col-sm-12">&nbsp;</div>
                                        <div class="col-sm-6">
                                            <label>Tanggal</label>
                                            <div class="input-group mb-3">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text"><i
                                                            class="fab fa-creative-commons-share"></i></span>
                                                </div>
                                                <input type="date" class="form-control form-control-sm" :id="'tanggal'"
                                                    :name="'tanggal'" placeholder="Tanggal" v-model="tanggal">
                                            </div>
                                        </div>
                                        <div class="col-sm-6">
                                            <label>Target Penyelesaian</label>
                                            <div class="input-group mb-3">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text"><i
                                                            class="fab fa-creative-commons-share"></i></span>
                                                </div>
                                                <input type="date" class="form-control form-control-sm"
                                                    :id="'target_penyelesaian'" :name="'target_penyelesaian'"
                                                    placeholder="Target Penyelesaian" v-model="target_penyelesaian">
                                            </div>
                                        </div>
                                        <div class="col-sm-12">
                                            <label>Kendala</label>
                                            <div class="row">
                                                <div class="col-sm-12">
                                                    <quill-editor v-model:value="kendala"
                                                        style="height: 25vh;background-color: #ffffff;"></quill-editor>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-12">&nbsp;</div>
                                        <div class="col-sm-12">
                                            <label>Tindak Lanjut</label>
                                            <div class="row">
                                                <div class="col-sm-12">
                                                    <quill-editor v-model:value="tindaklanjut"
                                                        style="height: 25vh;background-color: #ffffff;"></quill-editor>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-12">&nbsp;</div>
                                        <div class="col-sm-12">
                                            <label>Penanggungjawab</label>
                                            <div class="input-group mb-3">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text"><i
                                                            class="fab fa-creative-commons-share"></i></span>
                                                </div>
                                                <input type="text" class="form-control form-control-sm"
                                                    :id="'penanggungjawab'" :name="'penanggungjawab'"
                                                    placeholder="Penanggungjawab" v-model="penanggungjawab">
                                            </div>
                                        </div>
                                        <div class="col-sm-12">
                                            <label>Foto<small class="text-info"> (*jpg)</small>
                                            </label>
                                            <div class="input-group mb-3">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text"><i
                                                            class="far fa-file-image"></i></span>
                                                </div>
                                                <input type="file" class="form-control form-control-sm"
                                                    id="fileToUploadfilenya_kendala" name="fileToUploadfilenya_kendala"
                                                    placeholder="fileToUpload" style="font-size: smaller;"
                                                    accept="image/*">
                                                <input type="hidden" class="form-control form-control-sm"
                                                    id="filenya_kendala" name="filenya_kendala"
                                                    placeholder="File Beranda">
                                            </div>
                                        </div>
                                        <div class="col-sm-12">
                                            <label>Opsi</label>
                                            <div class="row">
                                                <div class="col-sm-9">
                                                    <div class="progress">
                                                        <div class="progress-bar" role="progressbar" aria-valuenow="0"
                                                            aria-valuemin="0" aria-valuemax="100" style="width:0%"
                                                            id="persennyafilenya_kendala">
                                                            <span id="tulisanpersenfilenya_kendala">0%</span>
                                                        </div>
                                                    </div>
                                                    <br>
                                                    <span class="text-success" id="suksesnyafilenya_kendala"></span>
                                                </div>
                                                <div class="col-sm-3 text-center">
                                                    <button type="button"
                                                        class="btn btn-warning btn-sm lebar text-white"
                                                        @click="uploadfile('filenya_kendala', 'image/*')">Upload
                                                        File</button>
                                                    <button type="button" class="btn btn-danger btn-sm lebar"
                                                        @click="clearfilepeta('filenya_kendala')">Hapus
                                                        File</button>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-12">
                                            <button type="button"
                                                class="btn btn-sm btn-success3 float-left text-white lebar2"
                                                @click="simpan()" v-if="(mode == '')" data-toggle="tooltip"
                                                data-placement="left" title="Simpan data.."><i
                                                    class="fas fa-plus-square"></i>
                                                Simpan</button>
                                            <button type="button"
                                                class="btn btn-sm btn-success3 float-left text-white lebar2"
                                                v-if="(mode != '')" @click="update()" data-toggle="tooltip"
                                                data-placement="left" title="Update data.."><i
                                                    class="fa fa-check-circle"></i>
                                                Update</button>
                                            <button type="button" v-if="(mode != '')"
                                                class="btn btn-sm btn-danger3 float-left text-white lebar2"
                                                @click="bataledit()" data-toggle="tooltip" data-placement="left"
                                                title="Batalkan proses.."><i class="fas fa-window-close"></i>
                                                Batal</button>
                                        </div>
                                        <div class="col-sm-12">&nbsp;</div>
                                    </div>
                                </div>
                                <div class="col-sm-12">&nbsp;</div>
                            </div>
                            <div class="card cardputih2">
                                <div class="card-header border-transparent">
                                    <h3 class="card-title">Daftar Kendala Dan Tindak Lanjut</h3>
                                    <div class="card-tools">
                                        <button type="button" class="btn btn-tool" data-card-widget="collapse">
                                            <i class="fas fa-minus"></i>
                                        </button>
                                    </div>
                                </div>
                                <div class="card-body p-3">
                                    <div class="row">
                                        <div class="col-sm-12">
                                            Paket Pekerjaan: {{ Nama_Kegiatan }}
                                        </div>
                                        <div class="col-sm-12">
                                            <div class="table-responsive table-wrapper">
                                                <table class="table m-0" id="tabeldata" style="font-size: small;">
                                                    <thead>
                                                        <tr>
                                                            <th style="width: 50px;">No</th>
                                                            <th style="width: 150px;">Opsi</th>
                                                            <th style="width: 50px;">Tanggal</th>
                                                            <th style="width: 100px;">Kendala</th>
                                                            <th style="width: 100px;">Tindak Lanjut</th>
                                                            <th style="width: 100px;">Target Penyelesaian</th>
                                                            <th style="width: 100px;">Penanggungjawab</th>
                                                            <th style="width: 100px;">Foto</th>
                                                        </tr>
                                                    </thead>
                                                    <template v-for="(datalist, urutlist) in datamaster"
                                                        :key="urutlist">
                                                        <tbody>
                                                            <tr>
                                                                <td class="text-center">{{ urutlist + 1 }}</td>
                                                                <td class="text-center">
                                                                    <button type="button"
                                                                        class="btn btn-primary3 btn-sm text-white"
                                                                        @click="prosesdata(datalist.id)"
                                                                        data-toggle="tooltip" data-placement="left"
                                                                        title="Edit data..">&nbsp;&nbsp;<i
                                                                            class="fas fa-edit"></i>
                                                                        Edit Data&nbsp;&nbsp;</button>
                                                                    <button type="button"
                                                                        class="btn btn-danger3 btn-sm text-white"
                                                                        @click="hapus(datalist.id)"
                                                                        data-toggle="tooltip" data-placement="left"
                                                                        title="Hapus data.."><i
                                                                            class="fas fa-trash-alt"></i> Hapus
                                                                        Data</button>
                                                                </td>
                                                                <td class="text-center">
                                                                    {{ G_formatDateNonWIB(datalist.tanggal) }}
                                                                </td>
                                                                <td>
                                                                    <span v-html="Dekriptext(datalist.kendala)"></span>
                                                                </td>
                                                                <td>
                                                                    <span
                                                                        v-html="Dekriptext(datalist.tindaklanjut)"></span>
                                                                </td>
                                                                <td>
                                                                    {{ G_formatDateNonWIB(datalist.target_penyelesaian)
                                                                    }}
                                                                </td>
                                                                <td>
                                                                    {{ datalist.penanggungjawab }}
                                                                </td>
                                                                <td class="text-center">
                                                                    <img :src="filenya_foto + datalist.filenya_kendala"
                                                                        style="height: 100px;">
                                                                    </img>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </template>
                                                    <tbody v-if="(datapesan == 'data kosong')">
                                                        <tr>
                                                            <label>Data masih kosong</label>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-footer p-3">
                                    <button type="button" class="btn btn-sm btn-danger3 float-left text-white lebar2"
                                        @click="batalproses()" data-toggle="tooltip" data-placement="left"
                                        title="Batalkan proses.."><i class="fas fa-window-close"></i>
                                        Tutup</button>
                                </div>
                                <div class="col-sm-12">&nbsp;</div>
                                <div class="col-sm-12">&nbsp;</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Footer />
    </div>
</template>

<script>
import $ from 'jquery';
import axios from 'axios';
import vSelect from 'vue-select';
import swal from 'sweetalert2';
import CryptoJS from 'crypto-js';
import { useRoute } from 'vue-router';
import { watch } from 'vue';
import { quillEditor } from 'vue3-quill';
import Footer from "../../componen/Footer.vue";
import NavBar from "../../componen/NavBar.vue";
import Menu from "../../componen/Menu.vue";

import VueApexCharts from "vue3-apexcharts";
window.Apex.chart = { fontFamily: "Poppins-SemiBold, Arial, sans-serif" };
export default {
    setup() {
        const route = useRoute()
        watch(() => route.name, () => {
        });

        return { route };
    },
    components: {
        Footer, NavBar, Menu, vSelect, swal, quillEditor
    },
    data() {
        return {
            halamanloading: true,
            iduser: JSON.parse(localStorage.getItem("usistem")),
            leveluser: JSON.parse(localStorage.getItem("lsistem")),
            namauser: JSON.parse(localStorage.getItem("nmusistem")),
            secretencData: decodeURIComponent(CryptoJS.AES.decrypt(this.route.params.id, 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString(CryptoJS.enc.Utf8)),
            Nama_Kegiatan: '',
            jumlahminggu: '',
            datamaster: [],
            validasi: false,
            idnya: '',
            tanggal: '',
            target_penyelesaian: '',
            kendala: '',
            tindaklanjut: '',
            penanggungjawab: '',
            filenya_kendala: '',
            filenya_foto: process.env.VUE_APP_URL_API + 'parastapainnovation_kendala-Foto?f=',
            mode: '',
            project_id: process.env.VUE_APP_PROJECT_ID,
        }
    },
    methods: {
        initialize() {
            //Initialize Select2 Elements
            $(".select2").select2();

            //Initialize Select2 Elements
            $(".select2bs4").select2({
                theme: "bootstrap4",
            });
            $('[data-mask]').inputmask();
            //$('#summernote').summernote();
        },
        hapus(kode) {
            swal.fire({
                title: "Konfirmasi",
                text: "Yakin Hendak Hapus Data?",
                icon: "warning",
                showCancelButton: true,
                cancelButtonText: "Batal",
                confirmButtonColor: "#3a4767",
                cancelButtonColor: "#ffaa05",
                confirmButtonText: "Hapus"
            }).then((result) => {
                if (result.isConfirmed) {
                    const data = { kode: kode, project_id: this.project_id, deletedby: JSON.parse(localStorage.getItem("isistem")) }
                    const mainAPI = axios.create({
                        baseURL: process.env.VUE_APP_URL_API,
                        headers: {
                            Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                            "Content-Type": "application/x-www-form-urlencoded",
                        },
                    });
                    mainAPI.post("parastapainnovation_kendala-Delete", data).then(
                        Response => {
                            var bytes = encodeURIComponent(CryptoJS.AES.encrypt(this.secretencData, 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString());
                            if (Response.data.response == 'error') {
                                swal.fire('Peringatan', Response.data.message, 'error');
                            }
                            else {
                                swal.fire('Informasi', 'Data telah dihapus..', 'success').then(function () {
                                    window.location.replace("/KendalaTindakLanjutKonsultan/" + bytes);
                                });
                            }
                        }
                    ).catch(
                        error => {
                            swal.fire('Peringatan', 'Terjadi Kesalahan Format Data', 'error');
                        }
                    )

                }
            });
            return false;
        },
        async prosesdata(kode) {
            this.mode = 'edit';
            this.halamanloading = true;
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            var random = Math.random();
            //alert(this.selectedid_user);
            await mainAPI.get("parastapainnovation_kendala-GetByID?random=" + random + "&project_id=" + this.project_id + "&kode=" + this.secretencData + "&id=" + kode + "&create=" + JSON.parse(localStorage.getItem("isistem"))).then(
                Response => {
                    this.datapesan = Response.data.message;
                    this.Nama_Kegiatan = '';
                    this.tanggal = '';
                    this.idnya = '';
                    this.target_penyelesaian = '';
                    this.kendala = '';
                    this.tindaklanjut = '';
                    this.penanggungjawab = '';
                    this.filenya_kendala = '';
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.tanggal = Response.data.content.data[0].tanggal;
                        this.idnya = Response.data.content.data[0].id;
                        this.target_penyelesaian = Response.data.content.data[0].target_penyelesaian;
                        this.kendala = atob(Response.data.content.data[0].kendala);
                        this.tindaklanjut = atob(Response.data.content.data[0].tindaklanjut);
                        this.penanggungjawab = Response.data.content.data[0].penanggungjawab;
                        this.filenya_kendala = Response.data.content.data[0].filenya_kendala;
                        document.getElementById('filenya_kendala').value = Response.data.content.data[0].filenya_kendala;
                        this.Nama_Kegiatan = Response.data.content.Nama_Kegiatan;
                        this.halamanloading = false;
                    }
                    else {
                        this.Nama_Kegiatan = Response.data.content.Nama_Kegiatan;
                        this.tanggal = '';
                        this.idnya = '';
                        this.target_penyelesaian = '';
                        this.kendala = '';
                        this.tindaklanjut = '';
                        this.penanggungjawab = '';
                        this.filenya_kendala = '';
                        document.getElementById('filenya_kendala').value = '';
                        this.halamanloading = false;
                    }

                }
            ).catch(error => {
                //console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });
        },
        bataledit() {
            this.mode = '';
            this.tanggal = '';
            this.idnya = '';
            this.target_penyelesaian = '';
            this.kendala = '';
            this.tindaklanjut = '';
            this.penanggungjawab = '';
            this.filenya_kendala = '';
            document.getElementById('filenya_kendala').value = '';
        },
        simpan() {
            this.validasidata();
            if (this.validasi == false) {
                return false;
            }

            var fd = new FormData();
            fd.append("tanggal", this.tanggal);
            fd.append("kendala", this.kendala);
            fd.append("tindaklanjut", this.tindaklanjut);
            fd.append("target_penyelesaian", this.target_penyelesaian);
            fd.append("penanggungjawab", document.getElementById('penanggungjawab').value);
            fd.append("project_id", this.project_id);
            fd.append("filenya_kendala", document.getElementById('filenya_kendala').value);
            fd.append("kode", this.secretencData);
            fd.append("createdby", JSON.parse(localStorage.getItem("isistem")));

            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    "Content-Type": "form-data",
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            mainAPI.post("parastapainnovation_kendala-AddKendala", fd).then(
                Response => {
                    var bytes = encodeURIComponent(CryptoJS.AES.encrypt(this.secretencData, 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString());
                    if (Response.data.response == 'error') {
                        swal.fire('Peringatan', Response.data.message, 'error');
                    }
                    else {
                        swal.fire('Informasi', 'Data telah tersimpan..', 'success').then(function () {
                            window.location.replace("/KendalaTindakLanjutKonsultan/" + bytes);
                        });
                    }
                }
            ).catch(function (error) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: error
                });
            }
            )
        },
        formattulisrupiah(kodenya) {
            var rupiah = document.getElementById(kodenya);
            rupiah.addEventListener('keyup', function (e) {
                // tambahkan 'Rp.' pada saat form di ketik
                // gunakan fungsi formatRupiah() untuk mengubah angka yang di ketik menjadi format angka
                rupiah.value = formatRupiah(this.value, '');
            });

            /* Fungsi formatRupiah */
            function formatRupiah(angka, prefix) {
                var separator = '';
                var number_string = angka.replace(/[^,\d]/g, '').toString(),
                    split = number_string.split(','),
                    sisa = split[0].length % 3,
                    rupiah = split[0].substr(0, sisa),
                    ribuan = split[0].substr(sisa).match(/\d{3}/gi);

                // tambahkan titik jika yang di input sudah menjadi angka ribuan
                if (ribuan) {
                    separator = sisa ? '.' : '';
                    rupiah += separator + ribuan.join('.');
                }

                rupiah = split[1] != undefined ? rupiah + ',' + split[1] : rupiah;
                return prefix == undefined ? rupiah : (rupiah ? rupiah : '');
            }
        },
        getOtentifikasi() {
            var time = Date.parse(localStorage.getItem("tsistem"));
            var timeakhir = time + (3 * 60 * 60 * 1000);
            var timesekarang = Date.parse(new Date());
            if (timesekarang > timeakhir) {
                this.ClearlocalStorage();
            }
            this.halamanloading = false;
        },
        ontabelChange(a) {
            try {
                this.selectedtabel = this.tabel[a].tag;
            }
            catch (err) {
                return;
            }
        },
        batalproses() {
            window.location.replace("/Konsultan");
        },
        uploadfile(idnya, tipenya) {
            var elmnt = document.getElementById("fileToUpload" + idnya);
            try {
                var namanya = elmnt.files[0].name;
                //alert(elmnt.files[0]['type'].toUpperCase());
                if (tipenya == 'image/*') {
                    if ((elmnt.files[0]['type'].toUpperCase() != 'IMAGE/JPG') && (elmnt.files[0]['type'].toUpperCase() != 'IMAGE/JPEG') && (elmnt.files[0]['type'].toUpperCase() != 'IMAGE/PNG') && (elmnt.files[0]['type'].toUpperCase() != 'IMAGE/GIF')) {
                        document.getElementById('suksesnya' + idnya).innerHTML = '*file harus format gambar';
                        return;
                    }
                }
                else {
                    if (elmnt.files[0]['type'] != tipenya) {
                        document.getElementById('suksesnya' + idnya).innerHTML = '*file harus format pdf';
                        return;
                    }
                }
            } catch (error) {
                document.getElementById('suksesnya' + idnya).innerHTML = '*pilih file terlebih dahulu';
                return;
            }
            var fd = new FormData();
            fd.append("fileToUpload", elmnt.files[0], elmnt.files[0].name);
            fd.append("folderToUpload", idnya);
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    "Content-Type": "form-data",
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            mainAPI.post("parastapainnovationpeta-FilesUpload", fd, {
                onUploadProgress: function (uploadEvent) {
                    document.getElementById('persennya' + idnya).style.width = Math.round((uploadEvent.loaded / uploadEvent.total) * 100) + "%";
                    document.getElementById('tulisanpersen' + idnya).innerHTML = Math.round((uploadEvent.loaded / uploadEvent.total) * 100) + "%";
                }
            }).then(
                function (res) {
                    document.getElementById('suksesnya' + idnya).innerHTML = res.data.message;
                    if (res.data.filename != undefined) {
                        document.getElementById(idnya).value = res.data.filename;
                    }
                }
            ).catch(function (e) {
                document.getElementById('suksesnya' + idnya).innerHTML = res.data.message;
                document.getElementById(idnya).value = '';
                console.log(e);
            }
            )
        },
        clearfilepeta(idnya) {
            if (document.getElementById(idnya).value == '') {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'File Tidak Tersedia',
                });
                return false;
            }

            var fd = new FormData();
            fd.append("folderToUpload", idnya);
            fd.append("filenya", document.getElementById(idnya).value);
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    "Content-Type": "form-data",
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            mainAPI.post("parastapainnovationpeta-FilesDeleted", fd).then(
                Response => {
                    swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 3000
                    }).fire({
                        icon: 'warning',
                        title: Response.data.message,
                    });
                    document.getElementById(idnya).value == '';
                    this.filenya_kendala = '';
                }
            ).catch(function (error) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: error
                });
            }
            )

            document.getElementById('fileToUpload' + idnya).value = '';
            document.getElementById(idnya).value = '';
            document.getElementById('persennya' + idnya).style.width = "0%";
            document.getElementById('tulisanpersen' + idnya).innerHTML = "0%";
            document.getElementById('suksesnya' + idnya).innerHTML = '';
            return false;
        },
        async AmbilDataSingel() {
            this.halamanloading = true;
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            var random = Math.random();
            //alert(this.selectedid_user);
            await mainAPI.get("parastapainnovation_kendala-GetData?random=" + random + "&project_id=" + this.project_id + "&kode=" + this.secretencData + "&create=" + JSON.parse(localStorage.getItem("isistem"))).then(
                Response => {
                    this.datapesan = Response.data.message;
                    this.Nama_Kegiatan = '';
                    this.datamaster = [];
                    //alert(this.datapesan);
                    if (this.datapesan == 'data diketemukan') {
                        this.datamaster = [];
                        this.datamaster = Response.data.content.data;
                        this.Nama_Kegiatan = Response.data.content.Nama_Kegiatan;
                        this.halamanloading = false;
                    }
                    else {
                        this.Nama_Kegiatan = Response.data.content.Nama_Kegiatan;
                        this.datamaster = [];
                        this.halamanloading = false;
                    }

                }
            ).catch(error => {
                //console.log(error);
                //this.ClearlocalStorage();
                this.halamanloading = false;
            });
        },
        validasidata() {
            if (document.getElementById('tanggal').value == '') {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Mohon Isikan Data',
                });
                document.getElementById('tanggal').focus();
                return false;
            }
            if (document.getElementById('target_penyelesaian').value == '') {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Mohon Isikan Data',
                });
                document.getElementById('target_penyelesaian').focus();
                return false;
            }
            if (this.kendala == '') {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Mohon Isikan Data Kendala',
                });
                return false;
            }
            if (this.tindaklanjut == '') {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Mohon Isikan Data Tindak Lanjut',
                });
                return false;
            }
            if (this.penanggungjawab == '') {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Mohon Isikan Data Penanggungjawab',
                });
                return false;
            }
            if (document.getElementById('filenya_kendala').value == '') {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: 'Mohon Isikan Foto',
                });
                return false;
            }
            this.validasi = true;
            return;
        },
        update() {
            this.validasidata();
            if (this.validasi == false) {
                return false;
            }
            var fd = new FormData();
            fd.append("tanggal", this.tanggal);
            fd.append("kendala", this.kendala);
            fd.append("tindaklanjut", this.tindaklanjut);
            fd.append("target_penyelesaian", this.target_penyelesaian);
            fd.append("penanggungjawab", document.getElementById('penanggungjawab').value);
            fd.append("project_id", this.project_id);
            fd.append("filenya_kendala", document.getElementById('filenya_kendala').value);
            fd.append("kode", this.secretencData);
            fd.append("updatedby", JSON.parse(localStorage.getItem("isistem")));
            fd.append("id", this.idnya);            
            const mainAPI = axios.create({
                baseURL: process.env.VUE_APP_URL_API,
                headers: {
                    "Content-Type": "form-data",
                    Authorization: "Bearer " + localStorage.getItem("tokensistem"),
                },
            });
            mainAPI.post("parastapainnovation_kendala-Update", fd).then(
                Response => {
                    var bytes = encodeURIComponent(CryptoJS.AES.encrypt(this.secretencData, 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString());
                    if (Response.data.response == 'error') {
                        swal.fire('Peringatan', Response.data.message, 'error');
                    }
                    else {
                        swal.fire('Informasi', 'Data telah terupdate..', 'success').then(function () {
                            window.location.replace("/KendalaTindakLanjutKonsultan/" + bytes);
                        });
                    }
                }
            ).catch(function (error) {
                swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000
                }).fire({
                    icon: 'warning',
                    title: error
                });
            }
            )
            return false;
        },
    },
    mounted() {
        this.getOtentifikasi();
        this.initialize();
        this.AmbilDataSingel();
    }
}
</script>
<style></style>